import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../models/autentication.model';
import { LocalStorageAPP } from '../shared/util/constans';
import { environment } from '../../environments/environment';
import { UserData } from '../models/loggin.model';
import {jwtDecode} from 'jwt-decode';
import { JwtPayload } from '../models/jwt-payload';

@Injectable({
  providedIn: 'root'
})
export class AutenticationService {

  private ingresar: boolean = false;
  userData: Partial<UserData> = {     
    nombres: '',
    email: '',
    perfiles: [],
 };
  apiAuth = environment.Api_Conexion + '/acceso';
  constructor(private httpClient: HttpClient,
    
  ) { }


  loggedin(dataLogin: User) {
    return this.httpClient.post<User>(this.apiAuth, dataLogin, {
      observe: 'response',
    });
  }

  setUserData(data: User) {
    // this.userData = data;
    localStorage.setItem(
      LocalStorageAPP.userData,
      JSON.stringify(data)
    );
  }

  getUser(){
    const user = <User>JSON.parse(localStorage.getItem("userData")!);    
    return user;
  }

  habilitarlogeo() {
    return this.ingresar;
  }

  get getToken() {
    return localStorage.getItem(LocalStorageAPP.x_token) || '';
  }

  setToken(token: string) {
    localStorage.setItem(LocalStorageAPP.x_token, JSON.stringify(token));
  }

  isAuthenticated(): boolean {
    if (this.getToken) {
      return true;
    } else {
      return false;
    }
  }

  get getUserData() {
    if (localStorage.getItem(LocalStorageAPP.userData)) {
      this.userData = JSON.parse(
        localStorage.getItem(LocalStorageAPP.userData) || '{}'
      );
    }
    return this.userData;
  }

  validarToken() {
    return this.httpClient.get<boolean>(this.apiAuth + "/valid-token");
  }

  public get payLoadToken()  {
      return jwtDecode<JwtPayload>(this.getToken.replace("Bearer ", ""))
    }

}
